import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";

import { drawerItemsMain } from "./AdminDrawerItemsMain";

import AdminSettingScreen from "../../screens/AdminSettingScreen";
import AdminCustomDrawerContent from "../../../../components/custom/AdminCustomDrawerContent";
import AdminAccountProfileSetting from "../../screens/AdminAccountProfileSetting";

const Drawer = createDrawerNavigator();

export default function AdminHelpNavigator() {
  const dimensions = useWindowDimensions();

  return (
    <Drawer.Navigator
      initialRouteName="AdminHelp"
      screenOptions={{
        drawerStyle: {
          width: 180,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <AdminCustomDrawerContent drawerItems={drawerItemsMain()} {...props} />
      )}
    >
      <Drawer.Screen
        name="AdminSetting"
        component={AdminSettingScreen}
        options={{ title: "AdminSetting" }}
      />

      <Drawer.Screen
        name="AdminAccountProfileSetting"
        component={AdminAccountProfileSetting}
        options={{ title: "AdminAccountProfileSetting" }}
      />
    </Drawer.Navigator>
  );
}
